import { withRouter } from 'react-router-dom'
import { LOAD_MESSAGE, VISUALIZER_TYPE } from './MovimentacaoEstoqueTransferenciaHook'
import { connect } from 'react-redux'
import {
  Btn,
  CustomCalendar,
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  InputNumeroInteiro,
  InputText,
  InputTime,
  PageHeader,
} from '../../../../../components'
import React, { useEffect } from 'react'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useMovimentacaoEstoque from './MovimentacaoEstoqueTransferenciaHook'
import MovimentacaoContainerItem from '../../../../../components/MovimentacaoContainerItem/MovimentacaoContainerItem'
import { DataTable } from 'primereact/datatable'
import './MovimentacaoEstoqueTransferencia.css'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'

function MovimentacaoEstoqueTransferencia({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useMovimentacaoEstoque()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.PICKINGS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPickings(selectedTp, state.periodo.dataInicial, state.periodo.dataFinal)
        break

      case LOAD_MESSAGE.PALLETAREAS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPalletAreas(selectedTp, state.selectedPosicaoOrigem.id)
        break

      case LOAD_MESSAGE.PRODUTOS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getProdutos(selectedTp, state.selectedPosicaoOrigem.id)
        break

      case LOAD_MESSAGE.POSICOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPosicoesEstoque(selectedTp, state.selectedEstoque.id)
        break

      case LOAD_MESSAGE.POSICOES_ORIGEM:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPosicoesEstoqueOrigem(selectedTp, state.selectedEstoqueOrigem.id)
        break

      case LOAD_MESSAGE.MOVING:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.pathToRedirect) {
      history.push(state.pathToRedirect, { selectedPicking: state.selectedPick })
    }
  }, [state.pathToRedirect])

  return (
    <div>
      <PageHeader>8.4 - Movimentações de Estoque - Transferência</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => {}} showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-3">
              <CustomDropdown
                placeholder="Selecione uma Operação"
                optionLabel={'name'}
                options={state.operacoes}
                label={'Operação de Estoque'}
                onChange={value => localDispatch.onChange('selectedOperacao', value)}
                value={state.selectedOperacao}
              />
            </div>
            <div className="p-col-3">
              <CustomCalendar
                label={'Data da Movimentação'}
                onChange={value => localDispatch.onChange('dataMovimentacao', value)}
                value={state.dataMovimentacao}
              />
            </div>
            <div className="p-col-2" style={{  marginTop: -10 }}>
              <InputTime
                label={'Hora da Movimentação'}
                value={state.horaMovimentacao}
                onChange={value => localDispatch.onChange('horaMovimentacao', value)}
              />
            </div>
          </div>
          <div className="p-grid">
            <div className="p-col-3">
              <CustomDropdown
                placeholder="Selecionar um Estoque"
                optionLabel={'name'}
                options={state.estoques}
                label={'Estoque Origem'}
                onChange={value => localDispatch.onChange('selectedEstoqueOrigem', value)}
                value={state.selectedEstoqueOrigem}
              />
            </div>
            <div className="p-col-3">
              <CustomDropdown
                filter={true}
                placeholder="Selecione uma Posição"
                optionLabel={'name'}
                options={state.posicoesOrigem}
                label={'Posição Origem'}
                onChange={value => localDispatch.onChange('selectedPosicaoOrigem', value)}
                value={state.selectedPosicaoOrigem}
              />
            </div>
            <div className="p-col-3">
              <CustomDropdown
                placeholder="Selecionar um Tipo"
                optionLabel={'name'}
                options={VISUALIZER_TYPE}
                label={'Tipo de Visualização'}
                onChange={value => localDispatch.onChange('selectedVisualizer', value)}
                value={state.selectedVisualizer}
              />
            </div>
          </div>
          <div
            className="p-grid p-align-start"
            style={{
              margin: '0px 0px',
              padding: '10px',
              border: '0.5px solid #c8c8c8',
              borderRadius: '4px',
              height: '100%',
            }}
          >
            <>
              {state.selectedVisualizer ? (
                state.selectedVisualizer.name === 'Por Produto' ? (
                  <div
                    className="p-col-6 p-grid p-justify-center container-items relative scroll"
                    style={{ padding: 0 }}
                  >
                    <DataTable
                      value={state.produtos}
                      header={
                        <CustomDataTableHeader
                          onChange={value => localDispatch.onChange('globalFilter', value)}
                          children={
                            <div
                              style={{
                                display: 'inline-grid',
                                gap: '10px',
                                gridAutoFlow: 'column',
                                marginLeft: 20,
                              }}
                            >
                              <Btn
                                onClick={() =>
                                  localDispatch.onClickAlocar(
                                    state.pallets,
                                    state.selectedProdutos,
                                    state.selectedPosicao,
                                    state.selectedVisualizer.name,
                                    state.selectedPosicaoOrigem,
                                  )
                                }
                              >
                                Alocar
                              </Btn>
                              <Btn
                                onClick={() =>
                                  localDispatch.onClickDesalocar(
                                    state.pallets,
                                    state.selectedProdutos,
                                    state.selectedVisualizer.name,
                                    state.selectedPosicaoOrigem,
                                  )
                                }
                              >
                                Desalocar
                              </Btn>
                            </div>
                          }
                        />
                      }
                      selection={state.selectedProdutos}
                      onSelectionChange={e => localDispatch.onChange('selectedProdutos', e.value)}
                      globalFilter={state.globalFilter}
                      paginator={true}
                      rows={10}
                    >
                      <Column selectionMode="multiple" style={{ width: '3em' }} />
                      <Column field="name" header="Produto" />
                      <Column field="quantidade" header="Qte Total" style={tableCellCentered(80)} />
                      <Column
                        field="qte_alocar"
                        header="Qte Para Alocar"
                        body={produto => (
                          <InputNumeroInteiro
                            value={produto.qte_alocar}
                            onChange={value =>
                              localDispatch.onChangeProduto(produto.id, value, 'qte_alocar')
                            }
                          />
                        )}
                      />
                      <Column field="validade" header="Validade" />
                      <Column field="lote" header="Lote" />
                      <Column field="pos_estoque" header="Posição" />
                    </DataTable>
                  </div>
                ) : (
                  <div
                    className="p-col-6 p-grid p-justify-center container-items relative scroll"
                    style={{ padding: 0 }}
                  >
                    <div className="p-col-12 p-grid header-section">
                      <div className="p-col-5">
                        <InputText
                          placeholder="Pesquisar por código"
                          value={state.searchPallet}
                          onChange={value => localDispatch.onSearchPalletsChange(value)}
                        />
                      </div>
                      <div className="p-col-2" style={{ marginTop: 25 }}>
                        <Btn
                          onClick={() =>
                            localDispatch.onClickAlocar(
                              state.pallets,
                              state.selectedProdutos,
                              state.selectedPosicao,
                              state.selectedVisualizer.name,
                              state.selectedPosicaoOrigem,
                            )
                          }
                        >
                          Alocar
                        </Btn>
                      </div>
                      <div className="p-col-2" style={{ marginTop: 25 }}>
                        <Btn
                          onClick={() =>
                            localDispatch.onClickDesalocar(
                              state.pallets,
                              state.selectedProdutos,
                              state.selectedVisualizer.name,
                              state.selectedPosicaoOrigem,
                            )
                          }
                        >
                          Desalocar
                        </Btn>
                      </div>
                    </div>
                    {state.pallets.map((p, index) => (
                      <MovimentacaoContainerItem
                        key={index}
                        onClick={() => localDispatch.onClickPallets(p)}
                        line1={p.pallet_area_id}
                        line2={`Data da Movimentação ${p.data_movimentacao}`}
                        selected={p.selected}
                        alocated={p.alocated}
                      />
                    ))}
                  </div>
                )
              ) : (
                ''
              )}
              <div className="p-col-6" style={{ paddingTop: 0 }}>
                <div
                  className="p-grid"
                  style={{
                    margin: '0px 0px',
                    paddingLeft: '10px',
                    border: '0.5px solid transparent',
                    borderRadius: '4px',
                  }}
                >
                  <div
                    className="p-col-12 p-grid p-justify-center container-items relative"
                    id="scroll"
                    style={{ padding: 0, display: state.selectedVisualizer ? 'flex' : 'none' }}
                  >
                    <div className="p-col-12 p-grid header-section">
                      <div className="p-col-4">
                        <CustomDropdown
                          placeholder="Selecione um estoque"
                          optionLabel={'name'}
                          options={state.estoques}
                          label={'Estoques'}
                          onChange={value => localDispatch.onChange('selectedEstoque', value)}
                          value={state.selectedEstoque}
                        />
                      </div>
                      <div className="p-col-5">
                        <InputText
                          marginTop={25}
                          placeholder="Pesquisar por endereço"
                          value={state.searchPosicao}
                          onChange={value => localDispatch.onSearchPosicoesChange(value)}
                        />
                      </div>
                      <div className="p-col-2" style={{ marginTop: 25 }}>
                        <Btn
                          onClick={() =>
                            localDispatch.onClickConcluir(
                              state.pallets,
                              state.produtos,
                              state.dataMovimentacao,
                              state.horaMovimentacao,
                              state.selectedOperacao,
                              selectedTp,
                              state.selectedVisualizer,
                              state.selectedPosicaoOrigem,
                            )
                          }
                        >
                          {' '}
                          Concluir{' '}
                        </Btn>
                      </div>
                    </div>
                    {state.posicoes.map((p, index) => (
                      <MovimentacaoContainerItem
                        key={index}
                        onClick={() => localDispatch.onClickPosicao(p)}
                        line1={p.endereco}
                        line2={`Capacidade de Pallets: ${p.capacidade}`}
                        line3={p.pallets ? `Pallets Alocados: ${p.pallets}` : null}
                        line4={`Caixas Alocadas: ${p.caixas}`}
                        selected={state.selectedPosicao && state.selectedPosicao.id === p.id}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </>
          </div>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(MovimentacaoEstoqueTransferencia))
